import React from 'react';

const FinalPage = () => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontSize: '24px',
      fontWeight: 'bold'
    }}>
      Final Page
    </div>
  );
};

export default FinalPage;
